export const contextTransitionState = (landingPage) => ({
  page: landingPage || 'Home',
  navParams: null,
  navHistory: [],
});
